/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {inject, Injectable} from '@angular/core';
import {AuthService} from './auth.service';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {RedirectService} from './redirect.service';
import {Environment, EnvironmentCabinet} from 'compob2b-libs'
import {DEFAULT_SIGN_IN_ROUTE, SIGN_IN_ROUTE} from './app-routing.tokens';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  environment = inject(Environment);

  /**
   * Путь формы входа — политика приложения (SEO-8): у кабинета это `/sign-in`, у
   * админки `/cabinet/sign-in`. `optional` + дефолт нужны потому, что спеки строят
   * голый `Injector.create`, в котором фабрика `providedIn: 'root'` не срабатывает.
   */
  private readonly signInRoute = inject(SIGN_IN_ROUTE, {optional: true}) ?? DEFAULT_SIGN_IN_ROUTE;

  constructor(private readonly auth: AuthService, private readonly redirectService: RedirectService, private readonly router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const allowAnonymousView = (this.environment as EnvironmentCabinet).allowAnonymousView;

    if (!allowAnonymousView && this.auth.isAnonymous()) {
      this.router.navigate([...this.signInRoute]).then();
    } else {
      this.redirectService.next(state.url);
    }

    return this.auth.isAuthenticated();
  }
}
